<template>
  <div class="norms__group">
    <div class="norms__header">Parametry pacjenta</div>
    <div class="norms__elements norms__patient">
      <div class="norms__element norms__patient-age">
        <div class="norms__element-name">Data urodzenia</div>
        <div class="norms__element-data">
          <BaseInputDate
            test-id="DietDetailAssumptions"
            :model-value="birthdate"
            :max-date="maxDate"
            :min-date="minDate"
            @update:model-value="emit('update:birthdate', $event)"
          />
        </div>
      </div>
      <div class="norms__element norms__patient-gender">
        <div class="norms__element-name">Płeć</div>
        <div class="norms__element-data">
          <BaseRadio
            class="norms__patient-gender__radio"
            :model-value="male"
            label="Mężczyzna"
            @update:model-value="emit('update:male', $event)"
          />
          <BaseRadio
            class="norms__patient-gender__radio"
            :model-value="female"
            label="Kobieta"
            @update:model-value="emit('update:female', $event)"
          />
        </div>
      </div>
      <div class="norms__element norms__patient-pregnancy-lactation">
        <div class="norms__element-name">Stan fizjologiczny</div>
        <div class="norms__element-data">
          <div class="norms__patient-pregnancy">
            <BaseCheckbox
              class="norms__patient-pregnancy-active"
              :model-value="pregnancy"
              label="Ciąża"
              :disabled="!female"
              @update:model-value="emit('update:pregnancy', $event)"
            />
            <BaseRadio
              class="norms__patient-pregnancy-trimester"
              :model-value="pregnancyTrimesterOne"
              label="1 trymestr"
              :disabled="!pregnancy || !female"
              @update:model-value="emit('update:pregnancyTrimesterOne', $event)"
            />
            <BaseRadio
              class="norms__patient-pregnancy-trimester"
              :model-value="pregnancyTrimesterTwo"
              label="2 trymestr"
              :disabled="!pregnancy || !female"
              @update:model-value="emit('update:pregnancyTrimesterTwo', $event)"
            />
            <BaseRadio
              class="norms__patient-pregnancy-trimester"
              :model-value="pregnancyTrimesterThree"
              label="3 trymestr"
              :disabled="!pregnancy || !female"
              @update:model-value="
                emit('update:pregnancyTrimesterThree', $event)
              "
            />
          </div>
          <div class="norms__patient-lactation">
            <BaseCheckbox
              class="norms__patient-lactation-active"
              :model-value="lactation"
              label="Laktacja"
              :disabled="!female"
              @update:model-value="emit('update:lactation', $event)"
            />
            <BaseRadio
              class="norms__patient-lactation-period"
              :model-value="lactationZeroSix"
              label="0-6 miesięcy"
              :disabled="!lactation || !female"
              @update:model-value="emit('update:lactationZeroSix', $event)"
            />
            <BaseRadio
              class="norms__patient-lactation-period"
              :model-value="lactationAboveSix"
              label="powyżej 6 miesięcy"
              :disabled="!lactation || !female"
              @update:model-value="emit('update:lactationAboveSix', $event)"
            />
          </div>
        </div>
      </div>
      <div class="norms__element norms__patient-height">
        <div class="norms__element-name">Wzrost</div>
        <div class="norms__element-data">
          <BaseInputNumber
            test-id="DietDetailAssumptions__Height"
            class="filter-number"
            :model-value="height"
            :min="1"
            :max="250"
            :precision="1"
            :step="0.1"
            @update:model-value="emit('update:height', $event)"
          />
          <span>cm</span>
        </div>
      </div>
      <div class="norms__element norms__patient-weight">
        <div class="norms__element-name">Masa ciała</div>
        <div class="norms__element-data">
          <BaseInputNumber
            test-id="DietDetailAssumptions__Weight"
            class="filter-number"
            :model-value="weight"
            :min="0.1"
            :max="250"
            :precision="1"
            :step="0.1"
            @update:model-value="emit('update:weight', $event)"
          />
          <span>kg</span>
        </div>
      </div>
      <div class="norms__element norms__patient-activity-level">
        <div class="norms__element-name">Aktywność fizyczna</div>
        <div class="norms__element-data">
          <BaseSelect
            :model-value="activityLevel"
            :options="activityLevelOptions"
            @update:model-value="emit('update:activityLevel', $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import BaseCheckbox from '@/components/BaseCheckbox.vue'
  import BaseInputDate from '@/components/BaseInputDate.vue'
  import BaseInputNumber from '@/components/BaseInputNumber.vue'
  import BaseRadio from '@/components/BaseRadio.vue'
  import BaseSelect from '@/components/BaseSelect.vue'
  import { activityLevelOptions } from '@/utils/common'

  defineProps<{
    activityLevel: number
    birthdate: string
    female: boolean
    height: number
    lactation: boolean
    lactationAboveSix: boolean
    lactationZeroSix: boolean
    male: boolean
    maxDate: Date
    minDate: Date
    pregnancy: boolean
    pregnancyTrimesterOne: boolean
    pregnancyTrimesterThree: boolean
    pregnancyTrimesterTwo: boolean
    weight: number
  }>()
  const emit = defineEmits([
    'update:activityLevel',
    'update:birthdate',
    'update:female',
    'update:height',
    'update:lactation',
    'update:lactationAboveSix',
    'update:lactationZeroSix',
    'update:male',
    'update:pregnancy',
    'update:pregnancyTrimesterOne',
    'update:pregnancyTrimesterThree',
    'update:pregnancyTrimesterTwo',
    'update:weight',
  ])
</script>
